import * as PopoverPrimitive from '@radix-ui/react-popover';
import { forwardRef } from 'react';

/**
 * DatePicker向けのポップオーバー全体を管理するコンテナです。
 */
const Popover = PopoverPrimitive.Root;

/**
 * ポップオーバーを開閉するトリガー要素です。
 */
const PopoverTrigger = PopoverPrimitive.Trigger;

/**
 * Portal上に描画されるポップオーバーの内容領域です。
 */
const PopoverContent = forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={className}
      {...props}
    />
  </PopoverPrimitive.Portal>
));

export { Popover, PopoverContent, PopoverTrigger };
